import { useEffect } from 'react'

import { ExplicitChangeTextInput } from '../../../common/components/explicit-change-text-input'
import { usePageEditorContext } from '../../contexts/page-editor.context'
import { Accordion, AccordionSummary, AccordionDetails } from '../../editor/sidebar-accordion'
import { ManualBlockEditor } from '../../editor/manual-block-editor'
import { CategoryListEdit } from '../category-list-edit'
import { reportDataSetService } from '../../editor/report-data-set.service'
import { HeaderEditAccordion } from '../header-edit-accordion'
import { FooterEditAccordion } from '../footer-edit-accordion'
import { reportBlockService } from '../../blocks/report-block.service'
import { FilterEditAccordion } from '../filter-edit-accordion'
import { SplitChartFilterEditAccordion } from '../split-chart-filter-edit-accordion'

export const SunburstBlockEditSidebar = function ({ block }) {
  const pageEditorContext = usePageEditorContext() || {}

  const filterOptionLabels = reportDataSetService.getFilterOptionLabels(block)

  const modifyLabelsProps = function (pageEditorContext) {
    const props = pageEditorContext.currentEdit.block.props
    const dataLabels = reportDataSetService.getDataSetLabels(pageEditorContext.page, pageEditorContext.currentEdit.block.dataKey)

    if (isDeepEqual(dataLabels.sunburstTypes, props.types)) {
      delete props.types
    }
  }

  useEffect(() => {
    pageEditorContext.updateCurrentEdit({ onBeforeSave: modifyLabelsProps })

    if (!block.dataKey) {
      return
    }

    const dataLabels = reportDataSetService.getDataSetLabels(pageEditorContext.page, block.dataKey)

    if ((typeof dataLabels.sunburstTypes !== 'object') || (dataLabels.sunburstTypes === null)) {
      return
    }

    block.props.types = reportBlockService.getTheRightConfiguration(dataLabels.sunburstTypes, block.props.types)
    updateBlock(block)
  }, [])

  function updateBlock (block) {
    pageEditorContext.registerUnsavedChanges()
    pageEditorContext.updateCurrentEdit({ block: { ...block } })
  }

  function getBlockProp (prop, defaultValue) {
    if (block.props[prop] === undefined) {
      return defaultValue
    } else {
      return block.props[prop]
    }
  }

  function setBlockProp (prop, value) {
    block.props[prop] = value
    updateBlock(block)
  }

  function getLabelsList () {
    const types = block.props.types
    const labelsList = []
    for (const key in types) {
      labelsList.push({
        value: key,
        label: types[key]
      })
    }
    return [{ values: labelsList, disableReorder: true }]
  }

  function handleLabelsChange (updated) {
    block.props.types = {}
    updated[0].values.forEach(({ value, label }) => {
      block.props.types[value] = label
    })
    updateBlock(block)
  }

  if (!block.dataKey) {
    return <div className="report-editor-sidebar">
      <Accordion square defaultExpanded={true}>
        <AccordionSummary>
          Other
        </AccordionSummary>
        <AccordionDetails>
          <div className="field-grid">
            <div className="full-width-field">
              <ManualBlockEditor block={block} onChange={updateBlock} />
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  }

  return <div className="report-editor-sidebar">
    <Accordion square defaultExpanded={true}>
      <AccordionSummary>
        Labels
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field" data-qa="total-label-view">
            <ExplicitChangeTextInput
              size="medium"
              label="Total Label"
              value={getBlockProp('totalLabel', '')}
              onChange={(event) => {
                setBlockProp('totalLabel', event.target.value)
              }}
            />
          </div>
          {(block.props.types || true) &&
            <div className="full-width-field">
              <CategoryListEdit
                size="medium"
                hideCategoryDropdown={true}
                hideLabelToggles={true}
                listLabel="Legend"
                categories={getLabelsList()}
                onChange={(updatedList) => {
                  handleLabelsChange(updatedList)
                }}
              />
            </div>
          }
        </div>
      </AccordionDetails>
    </Accordion>
    {filterOptionLabels.filter(({ values, isSplitChartFilter }) => !isSplitChartFilter && values.length > 0).length > 0 && (
      <FilterEditAccordion block={block} />
    )}
    <SplitChartFilterEditAccordion block={block} />
    <HeaderEditAccordion block={block} />
    <FooterEditAccordion block={block} />
    <Accordion square>
      <AccordionSummary>
        Other
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <ManualBlockEditor block={block} onChange={updateBlock} />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  </div>
}

function isDeepEqual (val1, val2) {
  return JSON.stringify(val1) === JSON.stringify(val2)
}
